export default "__VITE_ASSET__CRw_Irr8__"